import React from "react";

/* 分隔条：拖动调整左栏宽度 · 双击恢复默认 · 键盘 ←/→ 微调；完整页 /chat 与悬浮沟通窗共用 */
export const Splitter = ({ sp, zh, testId = "chat-splitter", className = "" }) => (
  <div role="separator" aria-orientation="vertical" aria-valuenow={sp.w} aria-valuemin={180} aria-valuemax={480} tabIndex={0}
    data-testid={testId} data-width={sp.w} data-dragging={sp.dragging ? 1 : 0}
    onPointerDown={sp.onPointerDown} onDoubleClick={sp.reset} onKeyDown={sp.onKeyDown}
    title={zh ? "拖动调整宽度 · 双击恢复默认" : "Drag to resize · double-click to reset"}
    className={`group relative z-10 w-2 -mx-1 shrink-0 cursor-col-resize items-center justify-center outline-none focus-visible:bg-indigo-50 ${className}`}>
    <span className={`h-10 w-[3px] rounded-full transition-colors ${sp.dragging ? "bg-[#4F6BFF]" : "bg-slate-200 group-hover:bg-[#4F6BFF]/70"}`} />
  </div>
);
